import React from 'react';

interface Icon3DCodeProps {
  size?: string;
}

const Icon3DCode: React.FC<Icon3DCodeProps> = ({ size = 'w-6 h-6' }) => {
  return (
    <div className={`${size} relative inline-flex items-center justify-center`} style={{ perspective: '1200px' }}>
      <div 
        className="w-full h-full relative"
        style={{
          animation: 'rotate3d 4s linear infinite',
          transformStyle: 'preserve-3d'
        }}
      >
        <div 
          className="absolute w-1/3 h-1/4 rounded bg-gradient-to-br from-emerald-400 to-emerald-600 shadow-lg"
          style={{ left: '0%', top: '0%', boxShadow: '4px 4px 8px rgba(0,0,0,0.2)' }}
        />
        <div 
          className="absolute w-1/3 h-1/4 rounded bg-gradient-to-br from-cyan-400 to-cyan-600 shadow-lg"
          style={{ left: '33%', top: '38%', boxShadow: '4px 4px 8px rgba(0,0,0,0.2)' }}
        />
        <div 
          className="absolute w-1/3 h-1/4 rounded bg-gradient-to-br from-amber-400 to-amber-600 shadow-lg"
          style={{ left: '66%', top: '75%', boxShadow: '4px 4px 8px rgba(0,0,0,0.2)' }}
        />
        <style>{`
          @keyframes rotate3d {
            0% { transform: rotateX(0deg) rotateY(0deg); }
            100% { transform: rotateX(360deg) rotateY(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default Icon3DCode;
